import { NestedPartial } from "@vista/omnichannel-components-domain";
import { OccFilmConfig } from "@vista/omnichannel-components-ui";
import {defaultOccFilmConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/film'
import { FilmConfig } from "../../types";

export function getFilmConfigData(film:NestedPartial<FilmConfig>):OccFilmConfig {
    return {
        ...defaultOccFilmConfig,
        showWatchlistButtons:film?.showWatchlistButtons || defaultOccFilmConfig.showWatchlistButtons
    }
}